export default __webpack_public_path__ + "static/media/piano_4key.822dc57d.svg";